import { useState } from "react"
import { Link } from "@tanstack/react-router"
import { Menu } from "lucide-react"
import { Logo } from "@/components/logo"
import { NotificationBell } from "@/components/notification-bell"
import { DeskUserMenu } from "@/components/desk-user-menu"
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"
import { HiringConsiderationToggle } from "./hiring-consideration-toggle"

const NAV_LINKS: {
  to:
    | "/candidate"
    | "/candidate/applications"
    | "/candidate/saved"
    | "/candidate/messages"
  label: string
  exact?: boolean
}[] = [
  { to: "/candidate", label: "Discover", exact: true },
  { to: "/candidate/applications", label: "Applications" },
  { to: "/candidate/saved", label: "Saved" },
  { to: "/candidate/messages", label: "Messages" },
]

const activeLinkProps = {
  className: "mkt-nav-link mkt-nav-link--active",
}

/** Ink & lime chrome for the logged-in candidate desk (/candidate/*) only. */
export function CandidateHeader() {
  const [open, setOpen] = useState(false)

  return (
    <header className="mkt-nav mkt-nav--app home-wf">
      <div className="home-wf-shell mkt-nav-inner">
        <Link to="/candidate" className="home-wf-brand" aria-label="Hire candidate desk">
          <Logo />
        </Link>

        <nav className="mkt-nav-links" aria-label="Primary">
          {NAV_LINKS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeOptions={item.exact ? { exact: true } : undefined}
              className="mkt-nav-link"
              activeProps={activeLinkProps}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="mkt-nav-actions mkt-nav-actions--desktop">
          <HiringConsiderationToggle />
          <span className="mkt-nav-bell">
            <NotificationBell viewAllPath="/candidate/notifications" />
          </span>
          <DeskUserMenu />
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button type="button" className="mkt-nav-menu" aria-label="Open menu">
              <Menu className="size-5" aria-hidden />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="mkt-nav-sheet home-wf w-[min(100%,20rem)]">
            <SheetHeader>
              <SheetTitle className="sr-only">Menu</SheetTitle>
            </SheetHeader>
            <nav className="mkt-nav-drawer" aria-label="Mobile primary">
              {NAV_LINKS.map((item) => (
                <SheetClose asChild key={item.to}>
                  <Link
                    to={item.to}
                    activeOptions={item.exact ? { exact: true } : undefined}
                    className="mkt-nav-link"
                    activeProps={activeLinkProps}
                  >
                    {item.label}
                  </Link>
                </SheetClose>
              ))}
              <div className="mkt-nav-drawer-actions">
                <HiringConsiderationToggle className="mkt-hiring-toggle--drawer" />
                <span className="mkt-nav-bell">
                  <NotificationBell viewAllPath="/candidate/notifications" />
                </span>
                <DeskUserMenu variant="drawer" onNavigate={() => setOpen(false)} />
              </div>
            </nav>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  )
}
